import React, {useState, useEffect, useContext} from "react";
import {functions} from "../../constants/common-functions";
import {childDashboardsUtilisation} from "../../constants/dashboards-children";
import AmChartBubble from "../../components/AmChartBubble";
import {utilityDashboardComponentContainer} from "../../constants/styles";
import UtilityDashboardLayout from "../../components/dashboardlayouts/UtilityDashboardLayout";
import ChartCardLarge from "../../components/ChartCardLarge";
import {store} from '../../context/store';

export default function UtilisationHoursOccupiedUtilisationCapacity(){
	
	const [data1, setData1] = useState([]);
	const [loaded, setLoaded] = useState(false);
	
	const globalState = useContext(store);
			
		const utilisationSurveyId =
		    globalState?.state?.queryContext?.utilisationSurveyId ?? null;

	
	useEffect(() => {
		if(loaded === false){
			setLoaded(true);
		}
	
		loadData();
		
	}, []);
	
	const loadData = () => {
		loadData1();
	};
	
	const loadData1 = () => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgethoursoccupiedutilisationcapacity?utilisationSurveyId=" + utilisationSurveyId, setData1, handleData1);
	};
	
	
	const handleData1 = (results) => {
		console.log(results);
	};
	
	
	const refreshFunction = () => {
		loadData();
	};
 	
 	
	return (
		<UtilityDashboardLayout
		    title="Hours Occupied, Utilisation & Capacity"
		    childDashboards={childDashboardsUtilisation}
		    refreshFunction={refreshFunction}
		  >
		  <div style={utilityDashboardComponentContainer}>
  			  <ChartCardLarge title="Bubble Chart">
			  	<AmChartBubble
						chartId="utilisationhoursoccupiedutilisationcapacitychart"
						chartData={data1}
						categoryKey="workplaceCode"
						valueKey="capacity"
						yValueKey="utilisation"
						xValueKey="hoursOccupied"
						width="100%"
						height="100%"
				/>
  	  		  </ChartCardLarge>
  			</div>	  
		</UtilityDashboardLayout>
	);
}